"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/switch/style/css");

var _switch = _interopRequireDefault(require("antd/es/switch"));

require("antd/es/alert/style/css");

var _alert = _interopRequireDefault(require("antd/es/alert"));

require("antd/es/checkbox/style/css");

var _checkbox = _interopRequireDefault(require("antd/es/checkbox"));

require("antd/es/input/style/css");

var _input = _interopRequireDefault(require("antd/es/input"));

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

require("antd/es/message/style/css");

var _message2 = _interopRequireDefault(require("antd/es/message"));

var _ = _interopRequireWildcard(require("lodash"));

var _react = _interopRequireWildcard(require("react"));

var _withStyles = _interopRequireDefault(require("react-international-telephone-input/lib/withStyles"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _reselect = require("reselect");

var _typesafeActions = require("typesafe-actions");

var _Util = require("../../../components/util/Util");

var _notification = require("../../../redux/notification/notification.types");

var selectors = _interopRequireWildcard(require("../../../redux/selectors"));

var _user = require("../../../redux/user/user.types");

var _api = require("../../../redux/api/api.types");

require("./settings.scss");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const flagsImagePath = require("../../../assets/images/flags.png");

const initialState = {
  user: undefined,
  pseudoParticipants: [],
  editMobileVisible: false,
  editEmailVisible: false,
  editPasswordVisible: false,
  mobile: '',
  email: '',
  password: '',
  password2x: '',
  currentPassword: '',
  updatePseudoParticipants: false,
  passwordMessage: 'Password is required '
};

class SettingsLandingPage extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = initialState;

    this.rowClassName = (record, index) => {
      return index % 2 === 0 ? 'tr-even-color' : 'tr-odd-color';
    };

    this.updateMobileInState = (mobile, countryCode) => {
      this.setState({
        mobile
      });
    };

    this.cancelSaveMobile = () => {
      var _a;

      const mobile = ((_a = this.props.user) === null || _a === void 0 ? void 0 : _a.mobile) ? this.props.user.mobile : '';
      this.setState({
        mobile
      });
      this.setState({
        editMobileVisible: false
      });
    };

    this.saveMobile = () => {
      const {
        mobile
      } = this.state;
      this.props.updateMobile(mobile);
      this.setState({
        editMobileVisible: false
      });
    };

    this.updateEmailInState = event => {
      this.setState({
        email: event.target.value
      });
    };

    this.cancelSaveEmail = () => {
      var _a;

      this.setState({
        editEmailVisible: false,
        email: (_a = this.props.user) === null || _a === void 0 ? void 0 : _a.email
      });
    };

    this.saveEmail = () => {
      this.props.updateEmail(this.state.email);
      this.setState({
        editEmailVisible: false
      });
    };

    this.updatePasswordInState = event => {
      const {
        password2x
      } = this.state;
      let passwordMessage;

      if (!event.target.value) {
        passwordMessage = 'Password is required';
      } else if (event.target.value.length < 8) {
        passwordMessage = 'Password must be at least 8 characters';
      } else if (event.target.value !== password2x) {
        passwordMessage = 'Passwords should match';
      }

      this.setState({
        password: event.target.value,
        passwordMessage
      });
    };

    this.updatePassword2xInState = event => {
      const {
        password
      } = this.state;
      let passwordMessage;

      if (!event.target.value) {
        passwordMessage = 'Password is required';
      } else if (event.target.value !== password) {
        passwordMessage = 'Passwords should match';
      }

      this.setState({
        password2x: event.target.value,
        passwordMessage
      });
    };

    this.onCurrentPasswordChange = event => {
      this.setState({
        currentPassword: event.target.value
      });
    };

    this.onUpdatePseudoParticipantsChange = event => {
      this.setState({
        updatePseudoParticipants: event.target.checked
      });
    };

    this.cancelSavePassword = () => {
      this.setState({
        password: '',
        password2x: '',
        passwordMessage: undefined,
        editPasswordVisible: false
      });
    };

    this.savePassword = () => {
      const {
        password,
        password2x,
        currentPassword,
        updatePseudoParticipants
      } = this.state;
      const {
        updatePassword
      } = this.props;

      if (password && password === password2x && currentPassword) {
        updatePassword({
          password,
          currentPassword,
          updatePseudoParticipants
        });
        this.setState({
          editPasswordVisible: false,
          password: '',
          currentPassword: '',
          password2x: '',
          updatePseudoParticipants: false
        });
      }
    };

    this.notificationOrder = ['NEW_MESSAGE', 'NEW_MESSAGE_IN_MY_THREAD', 'THREAD_ASSIGNED_TO_ME', 'NEW_ASK_THE_EXPERT'];
  }

  componentDidMount() {
    var _a, _b;

    this.setState({
      mobile: (_a = this.props.user) === null || _a === void 0 ? void 0 : _a.mobile,
      email: (_b = this.props.user) === null || _b === void 0 ? void 0 : _b.email
    });
  }

  render() {
    const {
      user,
      pseudoParticipants,
      studyArms,
      studyId,
      updatePasswordStatus,
      clearStatus,
      isNonYAB
    } = this.props;
    const {
      editMobileVisible,
      mobile,
      editEmailVisible,
      email,
      editPasswordVisible,
      password,
      password2x,
      passwordMessage,
      currentPassword,
      updatePseudoParticipants
    } = this.state;

    if (!user) {
      return /*#__PURE__*/_react.default.createElement("div", null, " loading");
    }

    if (updatePasswordStatus.isSuccess) {
      _message2.default.success('Password updated successfully.');

      clearStatus((0, _typesafeActions.getType)(_user.updatePasswordAsync.success));
    } else if (updatePasswordStatus.isError) {
      if (updatePasswordStatus.errorStatus === 401) {
        _message2.default.error('Current password was incorrect.', 3);
      } else {
        _message2.default.error(updatePasswordStatus.errorMessage);
      }

      clearStatus((0, _typesafeActions.getType)(_user.updatePasswordAsync.failure));
    }

    let {
      notificationSubscriptions
    } = user;
    notificationSubscriptions = _.sortBy(notificationSubscriptions, ns => _.indexOf(this.notificationOrder, ns.label));

    const ateNewQuestionSub = _.find(notificationSubscriptions, ns => ns.label === 'NEW_ASK_THE_EXPERT');

    const ateAdHocSub = _.find(notificationSubscriptions, ns => ns.label === 'ASK_THE_EXPERT_AD_HOC');

    const inboxNewMessageSub = _.find(notificationSubscriptions, ns => ns.label === 'NEW_MESSAGE');

    const inboxNewMessageInMyThreadSub = _.find(notificationSubscriptions, ns => ns.label === 'NEW_MESSAGE_IN_MY_THREAD');

    const inboxThreadAssignedToMeSub = _.find(notificationSubscriptions, ns => ns.label === 'THREAD_ASSIGNED_TO_ME');

    const anyAppointmentAssignedSub = _.find(notificationSubscriptions, ns => ns.label === 'ANY_APPOINTMENT_ASSIGNED');

    const anyAppointmentDeletedSub = _.find(notificationSubscriptions, ns => ns.label === 'ANY_APPOINTMENT_DELETED');

    const anyAppointmentRescheduledSub = _.find(notificationSubscriptions, ns => ns.label === 'ANY_APPOINTMENT_RESCHEDULED');

    const myAppointmentAssignedSub = _.find(notificationSubscriptions, ns => ns.label === 'MY_APPOINTMENT_ASSIGNED');

    const myAppointmentDeletedSub = _.find(notificationSubscriptions, ns => ns.label === 'MY_APPOINTMENT_DELETED');

    const myAppointmentRescheduledSub = _.find(notificationSubscriptions, ns => ns.label === 'MY_APPOINTMENT_RESCHEDULED');

    const myAvailabilityAddedSub = _.find(notificationSubscriptions, ns => ns.label === 'MY_AVAILABILITY_ADD');

    const myAvailabilityDeletedSub = _.find(notificationSubscriptions, ns => ns.label === 'MY_AVAILABILITY_DELETED');

    const anyAvailabilityAddedSub = _.find(notificationSubscriptions, ns => ns.label === 'ANY_AVAILABILITY_ADD');

    const anyAvailabilityDeletedSub = _.find(notificationSubscriptions, ns => ns.label === 'ANY_AVAILABILITY_DELETED');

    const showMobileInputField = () => {
      this.setState({
        editMobileVisible: true
      });
    };

    const showEmailInputField = () => {
      this.setState({
        editEmailVisible: true
      });
    };

    const showPasswordInputField = () => {
      this.setState({
        editPasswordVisible: true
      });
    };

    return /*#__PURE__*/_react.default.createElement("div", {
      id: "settings"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "titleRow"
    }, /*#__PURE__*/_react.default.createElement("h3", null, "Details")), /*#__PURE__*/_react.default.createElement("div", {
      className: "details indent"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "settings-column"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Id:", user === null || user === void 0 ? void 0 : user.id), editMobileVisible ? /*#__PURE__*/_react.default.createElement("span", {
      className: "editable-field"
    }, /*#__PURE__*/_react.default.createElement(_withStyles.default, {
      value: mobile,
      flagsImagePath: flagsImagePath,
      onChange: this.updateMobileInState
    }), /*#__PURE__*/_react.default.createElement(_button.default, {
      className: "settings-button",
      onClick: this.saveMobile
    }, "Save"), /*#__PURE__*/_react.default.createElement(_button.default, {
      className: "settings-button",
      onClick: this.cancelSaveMobile
    }, "Cancel")) : /*#__PURE__*/_react.default.createElement("span", {
      className: "editable-field"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Mobile:", mobile || '(none)'), /*#__PURE__*/_react.default.createElement(_button.default, {
      className: "settings-button",
      onClick: showMobileInputField
    }, "Edit")), editEmailVisible ? /*#__PURE__*/_react.default.createElement("span", {
      className: "editable-field"
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      key: "email",
      onChange: this.updateEmailInState,
      value: email
    }), /*#__PURE__*/_react.default.createElement(_button.default, {
      className: "settings-button",
      onClick: this.saveEmail
    }, "Save"), /*#__PURE__*/_react.default.createElement(_button.default, {
      className: "settings-button",
      onClick: this.cancelSaveEmail
    }, "Cancel")) : /*#__PURE__*/_react.default.createElement("span", {
      className: "editable-field"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Email:", email || '(none)'), /*#__PURE__*/_react.default.createElement(_button.default, {
      className: "settings-button",
      onClick: showEmailInputField
    }, "Edit")), editPasswordVisible ? /*#__PURE__*/_react.default.createElement("span", {
      className: "editable-field active"
    }, "Current Password:", ' ', /*#__PURE__*/_react.default.createElement(_input.default.Password, {
      visibilityToggle: true,
      key: "current-password",
      onChange: this.onCurrentPasswordChange,
      value: currentPassword
    }), "New Password:", ' ', /*#__PURE__*/_react.default.createElement(_input.default.Password, {
      visibilityToggle: true,
      key: "pwd1",
      onChange: this.updatePasswordInState,
      value: password
    }), "Confirm New Password:", ' ', /*#__PURE__*/_react.default.createElement(_input.default.Password, {
      visibilityToggle: true,
      key: "pwd2",
      onChange: this.updatePassword2xInState,
      value: password2x
    }), /*#__PURE__*/_react.default.createElement(_checkbox.default, {
      onChange: this.onUpdatePseudoParticipantsChange,
      checked: updatePseudoParticipants
    }, "Also update pseudo-participant passwords associated with your user?"), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'row',
        paddingTop: '5px',
        alignContent: 'space-between',
        width: '100%'
      }
    }, passwordMessage ? /*#__PURE__*/_react.default.createElement(_alert.default, {
      type: "error",
      message: passwordMessage
    }) : /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      className: "settings-button",
      onClick: this.savePassword
    }, "Save")), /*#__PURE__*/_react.default.createElement(_button.default, {
      className: "settings-button",
      onClick: this.cancelSavePassword
    }, "Cancel"))) : /*#__PURE__*/_react.default.createElement("span", {
      className: "editable-field"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Password: ****************** "), /*#__PURE__*/_react.default.createElement(_button.default, {
      className: "settings-button",
      onClick: showPasswordInputField
    }, "Edit")))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: "titleRow"
    }, /*#__PURE__*/_react.default.createElement("h3", null, "Roles")), /*#__PURE__*/_react.default.createElement("div", null, _.map(user.roles, role => {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "details indent"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "settings-column"
      }, /*#__PURE__*/_react.default.createElement("p", null, role.role.role, " : ", role.role.description, ' ')));
    }))), (pseudoParticipants === null || pseudoParticipants === void 0 ? void 0 : pseudoParticipants.length) ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: "titleRow"
    }, /*#__PURE__*/_react.default.createElement("h3", null, "Pseudo Participants")), /*#__PURE__*/_react.default.createElement("div", {
      className: "tableRow"
    }, /*#__PURE__*/_react.default.createElement("table", {
      id: "pseudos-table"
    }, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", {
      style: {
        borderBottom: '1px solid #8185B3'
      }
    }, /*#__PURE__*/_react.default.createElement("th", null, "Username"), /*#__PURE__*/_react.default.createElement("th", null, "Study Arm"), /*#__PURE__*/_react.default.createElement("th", null, "Id"))), /*#__PURE__*/_react.default.createElement("tbody", null, _.map(pseudoParticipants, p => {
      return p ? /*#__PURE__*/_react.default.createElement("tr", {
        key: p.id
      }, /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement("a", {
        href: `/study/${studyId}/participants/${p.id}`
      }, p.username)), /*#__PURE__*/_react.default.createElement("td", null, (0, _Util.getStudyArmLabelFromId)(studyArms, p.studyArmId)), /*#__PURE__*/_react.default.createElement("td", null, p.id)) : undefined;
    }))))) : undefined, isNonYAB ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: "titleRow"
    }, /*#__PURE__*/_react.default.createElement("h3", null, "Notification Settings")), /*#__PURE__*/_react.default.createElement("div", {
      className: "titleRow indent"
    }, /*#__PURE__*/_react.default.createElement("h4", null, "Ask the Expert"), /*#__PURE__*/_react.default.createElement("p", {
      style: {
        paddingLeft: '145px'
      }
    }, "Email"), /*#__PURE__*/_react.default.createElement("p", {
      style: {
        paddingLeft: '20px'
      }
    }, "Sms")), /*#__PURE__*/_react.default.createElement("div", {
      className: "subRow"
    }, /*#__PURE__*/_react.default.createElement("p", null, "New Question"), " \u00A0 \u00A0", /*#__PURE__*/_react.default.createElement(_switch.default, {
      key: "switch-email-new-question",
      checked: ateNewQuestionSub.emailOn === 1,
      onChange: checked => {
        this.updateNotificationSubscription({ ...ateNewQuestionSub,
          emailOn: checked ? 1 : 0,
          userId: user.id
        });
      }
    }), /*#__PURE__*/_react.default.createElement(_switch.default, {
      key: "switch-sms-new-question",
      checked: ateNewQuestionSub.smsOn === 1,
      onChange: checked => {
        this.updateNotificationSubscription({ ...ateNewQuestionSub,
          smsOn: checked ? 1 : 0,
          userId: user.id
        });
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "subRow"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Question Assigned To Me"), " \u00A0 \u00A0", /*#__PURE__*/_react.default.createElement(_switch.default, {
      key: "switch-email-question-assigned-to-me",
      checked: ateAdHocSub.emailOn === 1,
      onChange: checked => {
        this.updateNotificationSubscription({ ...ateAdHocSub,
          emailOn: checked ? 1 : 0,
          userId: user.id
        });
      }
    }), /*#__PURE__*/_react.default.createElement(_switch.default, {
      key: "switch-sms-question-assigned-to-me",
      checked: ateAdHocSub.smsOn === 1,
      onChange: checked => {
        this.updateNotificationSubscription({ ...ateAdHocSub,
          smsOn: checked ? 1 : 0,
          userId: user.id
        });
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "titleRow indent"
    }, /*#__PURE__*/_react.default.createElement("h4", null, "Inbox"), /*#__PURE__*/_react.default.createElement("p", {
      style: {
        paddingLeft: '203px'
      }
    }, "Email"), /*#__PURE__*/_react.default.createElement("p", {
      style: {
        paddingLeft: '20px'
      }
    }, "Sms")), /*#__PURE__*/_react.default.createElement("div", {
      className: "subRow"
    }, /*#__PURE__*/_react.default.createElement("p", null, "New Message"), " \u00A0 \u00A0", /*#__PURE__*/_react.default.createElement(_switch.default, {
      key: "switch-email-new-message",
      checked: inboxNewMessageSub.emailOn === 1,
      onChange: checked => {
        this.updateNotificationSubscription({ ...inboxNewMessageSub,
          emailOn: checked ? 1 : 0,
          userId: user.id
        });

        if (checked) {
          this.updateNotificationSubscription({ ...inboxNewMessageInMyThreadSub,
            emailOn: 0,
            userId: user.id
          });
        }
      }
    }), /*#__PURE__*/_react.default.createElement(_switch.default, {
      key: "switch-sms-new-message",
      checked: inboxNewMessageSub.smsOn === 1,
      onChange: checked => {
        this.updateNotificationSubscription({ ...inboxNewMessageSub,
          smsOn: checked ? 1 : 0,
          userId: user.id
        });

        if (checked) {
          this.updateNotificationSubscription({ ...inboxNewMessageInMyThreadSub,
            smsOn: 0,
            userId: user.id
          });
        }
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "subRow"
    }, /*#__PURE__*/_react.default.createElement("p", null, "New Message In My Thread"), " \u00A0 \u00A0", /*#__PURE__*/_react.default.createElement(_switch.default, {
      key: "switch-email-new-messaage-thread",
      disabled: inboxNewMessageSub.emailOn === 1,
      checked: inboxNewMessageInMyThreadSub.emailOn === 1,
      onChange: checked => {
        this.updateNotificationSubscription({ ...inboxNewMessageInMyThreadSub,
          emailOn: checked ? 1 : 0,
          userId: user.id
        });
      }
    }), /*#__PURE__*/_react.default.createElement(_switch.default, {
      key: "switch-sms-new-messaage-thread",
      disabled: inboxNewMessageSub.smsOn === 1,
      checked: inboxNewMessageInMyThreadSub.smsOn === 1,
      onChange: checked => {
        this.updateNotificationSubscription({ ...inboxNewMessageInMyThreadSub,
          smsOn: checked ? 1 : 0,
          userId: user.id
        });
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "subRow"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Thread Assigned To Me"), " \u00A0 \u00A0", /*#__PURE__*/_react.default.createElement(_switch.default, {
      key: "switch-email-thread-assigned-to-me",
      checked: inboxThreadAssignedToMeSub.emailOn === 1,
      onChange: checked => {
        this.updateNotificationSubscription({ ...inboxThreadAssignedToMeSub,
          emailOn: checked ? 1 : 0,
          userId: user.id
        });
      }
    }), /*#__PURE__*/_react.default.createElement(_switch.default, {
      key: "switch-sms-thread-assigned-to-me",
      checked: inboxThreadAssignedToMeSub.smsOn === 1,
      onChange: checked => {
        this.updateNotificationSubscription({ ...inboxThreadAssignedToMeSub,
          smsOn: checked ? 1 : 0,
          userId: user.id
        });
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "titleRow indent"
    }, /*#__PURE__*/_react.default.createElement("h4", null, "Appointments"), /*#__PURE__*/_react.default.createElement("p", {
      style: {
        paddingLeft: '150px'
      }
    }, "Email"), /*#__PURE__*/_react.default.createElement("p", {
      style: {
        paddingLeft: '20px'
      }
    }, "Sms")), /*#__PURE__*/_react.default.createElement("div", {
      className: "subRow"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Any Appointment Assigned"), " \u00A0 \u00A0", /*#__PURE__*/_react.default.createElement(_switch.default, {
      key: "switch-email-any-appt-assig",
      checked: anyAppointmentAssignedSub.emailOn === 1,
      onChange: checked => {
        this.updateNotificationSubscription({ ...anyAppointmentAssignedSub,
          emailOn: checked ? 1 : 0,
          userId: user.id
        });

        if (checked) {
          this.updateNotificationSubscription({ ...anyAppointmentAssignedSub,
            emailOn: 0,
            userId: user.id
          });
        }
      }
    }), /*#__PURE__*/_react.default.createElement(_switch.default, {
      key: "switch-my-appt-assig",
      checked: anyAppointmentAssignedSub.smsOn === 1,
      onChange: checked => {
        this.updateNotificationSubscription({ ...anyAppointmentAssignedSub,
          smsOn: checked ? 1 : 0,
          userId: user.id
        });

        if (checked) {
          this.updateNotificationSubscription({ ...anyAppointmentAssignedSub,
            smsOn: 0,
            userId: user.id
          });
        }
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "subRow"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Any Appointment Deleted"), " \u00A0 \u00A0", /*#__PURE__*/_react.default.createElement(_switch.default, {
      key: "switch-email-my-appt-del",
      checked: anyAppointmentDeletedSub.emailOn === 1,
      onChange: checked => {
        this.updateNotificationSubscription({ ...anyAppointmentDeletedSub,
          emailOn: checked ? 1 : 0,
          userId: user.id
        });

        if (checked) {
          this.updateNotificationSubscription({ ...anyAppointmentDeletedSub,
            emailOn: 0,
            userId: user.id
          });
        }
      }
    }), /*#__PURE__*/_react.default.createElement(_switch.default, {
      key: "switch-ssms-my-appt-del",
      checked: anyAppointmentDeletedSub.smsOn === 1,
      onChange: checked => {
        this.updateNotificationSubscription({ ...anyAppointmentDeletedSub,
          smsOn: checked ? 1 : 0,
          userId: user.id
        });

        if (checked) {
          this.updateNotificationSubscription({ ...anyAppointmentDeletedSub,
            smsOn: 0,
            userId: user.id
          });
        }
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "subRow"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Any Appointment Rescheduled"), " \u00A0 \u00A0", /*#__PURE__*/_react.default.createElement(_switch.default, {
      key: "switch-email-any-appt-res",
      checked: anyAppointmentRescheduledSub.emailOn === 1,
      onChange: checked => {
        this.updateNotificationSubscription({ ...anyAppointmentRescheduledSub,
          emailOn: checked ? 1 : 0,
          userId: user.id
        });

        if (checked) {
          this.updateNotificationSubscription({ ...anyAppointmentRescheduledSub,
            emailOn: 0,
            userId: user.id
          });
        }
      }
    }), /*#__PURE__*/_react.default.createElement(_switch.default, {
      key: "switch-sms-any-appt-res",
      checked: anyAppointmentRescheduledSub.smsOn === 1,
      onChange: checked => {
        this.updateNotificationSubscription({ ...anyAppointmentRescheduledSub,
          smsOn: checked ? 1 : 0,
          userId: user.id
        });

        if (checked) {
          this.updateNotificationSubscription({ ...anyAppointmentRescheduledSub,
            smsOn: 0,
            userId: user.id
          });
        }
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "subRow"
    }, /*#__PURE__*/_react.default.createElement("p", null, "My Appointment Assigned"), " \u00A0 \u00A0", /*#__PURE__*/_react.default.createElement(_switch.default, {
      key: "switch-email-my-appt-ass",
      checked: myAppointmentAssignedSub.emailOn === 1,
      onChange: checked => {
        this.updateNotificationSubscription({ ...myAppointmentAssignedSub,
          emailOn: checked ? 1 : 0,
          userId: user.id
        });

        if (checked) {
          this.updateNotificationSubscription({ ...myAppointmentAssignedSub,
            emailOn: 0,
            userId: user.id
          });
        }
      }
    }), /*#__PURE__*/_react.default.createElement(_switch.default, {
      key: "switch-sms-my-appt-ass",
      checked: myAppointmentAssignedSub.smsOn === 1,
      onChange: checked => {
        this.updateNotificationSubscription({ ...myAppointmentAssignedSub,
          smsOn: checked ? 1 : 0,
          userId: user.id
        });

        if (checked) {
          this.updateNotificationSubscription({ ...myAppointmentAssignedSub,
            smsOn: 0,
            userId: user.id
          });
        }
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "subRow"
    }, /*#__PURE__*/_react.default.createElement("p", null, "My Appointment Deleted"), " \u00A0 \u00A0", /*#__PURE__*/_react.default.createElement(_switch.default, {
      key: "switch-email-my-appt-del",
      checked: myAppointmentDeletedSub.emailOn === 1,
      onChange: checked => {
        this.updateNotificationSubscription({ ...myAppointmentDeletedSub,
          emailOn: checked ? 1 : 0,
          userId: user.id
        });

        if (checked) {
          this.updateNotificationSubscription({ ...myAppointmentDeletedSub,
            emailOn: 0,
            userId: user.id
          });
        }
      }
    }), /*#__PURE__*/_react.default.createElement(_switch.default, {
      key: "switch-sms-my-appt-del",
      checked: myAppointmentDeletedSub.smsOn === 1,
      onChange: checked => {
        this.updateNotificationSubscription({ ...myAppointmentDeletedSub,
          smsOn: checked ? 1 : 0,
          userId: user.id
        });

        if (checked) {
          this.updateNotificationSubscription({ ...myAppointmentDeletedSub,
            smsOn: 0,
            userId: user.id
          });
        }
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "subRow"
    }, /*#__PURE__*/_react.default.createElement("p", null, "My Appointment Rescheduled"), " \u00A0 \u00A0", /*#__PURE__*/_react.default.createElement(_switch.default, {
      key: "switch-email-my-appt-res",
      checked: myAppointmentRescheduledSub.emailOn === 1,
      onChange: checked => {
        this.updateNotificationSubscription({ ...myAppointmentRescheduledSub,
          emailOn: checked ? 1 : 0,
          userId: user.id
        });

        if (checked) {
          this.updateNotificationSubscription({ ...myAppointmentRescheduledSub,
            emailOn: 0,
            userId: user.id
          });
        }
      }
    }), /*#__PURE__*/_react.default.createElement(_switch.default, {
      key: "switch-sms-my-appt-res",
      checked: myAppointmentRescheduledSub.smsOn === 1,
      onChange: checked => {
        this.updateNotificationSubscription({ ...myAppointmentRescheduledSub,
          smsOn: checked ? 1 : 0,
          userId: user.id
        });

        if (checked) {
          this.updateNotificationSubscription({ ...myAppointmentRescheduledSub,
            smsOn: 0,
            userId: user.id
          });
        }
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "titleRow indent"
    }, /*#__PURE__*/_react.default.createElement("h4", null, "Availability"), /*#__PURE__*/_react.default.createElement("p", {
      style: {
        paddingLeft: '150px'
      }
    }, "Email"), /*#__PURE__*/_react.default.createElement("p", {
      style: {
        paddingLeft: '20px'
      }
    }, "Sms")), /*#__PURE__*/_react.default.createElement("div", {
      className: "subRow"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Any Availability Added"), " \u00A0 \u00A0", /*#__PURE__*/_react.default.createElement(_switch.default, {
      key: "switch-email-any-avail-ass",
      checked: anyAvailabilityAddedSub.emailOn === 1,
      onChange: checked => {
        this.updateNotificationSubscription({ ...anyAvailabilityAddedSub,
          emailOn: checked ? 1 : 0,
          userId: user.id
        });

        if (checked) {
          this.updateNotificationSubscription({ ...anyAvailabilityAddedSub,
            emailOn: 0,
            userId: user.id
          });
        }
      }
    }), /*#__PURE__*/_react.default.createElement(_switch.default, {
      key: "switch-sms-any-avail-ass",
      checked: anyAvailabilityAddedSub.smsOn === 1,
      onChange: checked => {
        this.updateNotificationSubscription({ ...anyAvailabilityAddedSub,
          smsOn: checked ? 1 : 0,
          userId: user.id
        });

        if (checked) {
          this.updateNotificationSubscription({ ...anyAvailabilityAddedSub,
            smsOn: 0,
            userId: user.id
          });
        }
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "subRow"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Any Availability Deleted"), " \u00A0 \u00A0", /*#__PURE__*/_react.default.createElement(_switch.default, {
      key: "switch-email-any-avail-del",
      checked: anyAvailabilityDeletedSub.emailOn === 1,
      onChange: checked => {
        this.updateNotificationSubscription({ ...anyAvailabilityDeletedSub,
          emailOn: checked ? 1 : 0,
          userId: user.id
        });

        if (checked) {
          this.updateNotificationSubscription({ ...anyAvailabilityDeletedSub,
            emailOn: 0,
            userId: user.id
          });
        }
      }
    }), /*#__PURE__*/_react.default.createElement(_switch.default, {
      key: "switch-sms-any-avail-del",
      checked: anyAvailabilityDeletedSub.smsOn === 1,
      onChange: checked => {
        this.updateNotificationSubscription({ ...anyAvailabilityDeletedSub,
          smsOn: checked ? 1 : 0,
          userId: user.id
        });

        if (checked) {
          this.updateNotificationSubscription({ ...anyAvailabilityDeletedSub,
            smsOn: 0,
            userId: user.id
          });
        }
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "subRow"
    }, /*#__PURE__*/_react.default.createElement("p", null, "My Availability Added"), " \u00A0 \u00A0", /*#__PURE__*/_react.default.createElement(_switch.default, {
      key: "switch-email-my-avail-add",
      checked: myAvailabilityAddedSub.emailOn === 1,
      onChange: checked => {
        this.updateNotificationSubscription({ ...myAvailabilityAddedSub,
          emailOn: checked ? 1 : 0,
          userId: user.id
        });

        if (checked) {
          this.updateNotificationSubscription({ ...myAvailabilityAddedSub,
            emailOn: 0,
            userId: user.id
          });
        }
      }
    }), /*#__PURE__*/_react.default.createElement(_switch.default, {
      key: "switch-sms-my-avail-add",
      checked: myAvailabilityAddedSub.smsOn === 1,
      onChange: checked => {
        this.updateNotificationSubscription({ ...myAvailabilityAddedSub,
          smsOn: checked ? 1 : 0,
          userId: user.id
        });

        if (checked) {
          this.updateNotificationSubscription({ ...myAvailabilityAddedSub,
            smsOn: 0,
            userId: user.id
          });
        }
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "subRow"
    }, /*#__PURE__*/_react.default.createElement("p", null, "My Availability Deleted"), " \u00A0 \u00A0", /*#__PURE__*/_react.default.createElement(_switch.default, {
      key: "switch-email-my-avail-del",
      checked: myAvailabilityDeletedSub.emailOn === 1,
      onChange: checked => {
        this.updateNotificationSubscription({ ...myAvailabilityDeletedSub,
          emailOn: checked ? 1 : 0,
          userId: user.id
        });

        if (checked) {
          this.updateNotificationSubscription({ ...myAvailabilityDeletedSub,
            emailOn: 0,
            userId: user.id
          });
        }
      }
    }), /*#__PURE__*/_react.default.createElement(_switch.default, {
      key: "switch-sms-my-avail-del",
      checked: myAvailabilityDeletedSub.smsOn === 1,
      onChange: checked => {
        this.updateNotificationSubscription({ ...myAvailabilityDeletedSub,
          smsOn: checked ? 1 : 0,
          userId: user.id
        });

        if (checked) {
          this.updateNotificationSubscription({ ...myAvailabilityDeletedSub,
            smsOn: 0,
            userId: user.id
          });
        }
      }
    }))) : null);
  }

  updateNotificationSubscription(subscription) {
    console.log(subscription);
    this.props.updateNotificationSubscription(subscription);
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  user: selectors.getUser,
  pseudoParticipants: selectors.getCurrentUserPseudoParticipants,
  studyArms: selectors.getStudyArms,
  studyId: selectors.getRequestedStudyId,
  updatePasswordStatus: selectors.updatePasswordStatus,
  isNonYAB: selectors.isNonYAB
});

const mapDispatchToProps = dispatch => {
  return {
    updatePassword: args => dispatch(_user.updatePasswordAsync.request(args)),
    updateMobile: mobile => dispatch(_user.updateMobileAsync.request(mobile)),
    updateEmail: email => dispatch(_user.updateEmailAsync.request(email)),
    updateNotificationSubscription: subscription => dispatch(_notification.updateNotificationSubscriptionAsync.request(subscription)),
    clearStatus: type => dispatch((0, _api.clearStatus)(type))
  };
};

var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SettingsLandingPage));

exports.default = _default;